import { useInfiniteQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import getV1MFOrder from '@services/api/platform/mutual-fund/order';
import { rewriteStatusMF } from '../../utils/rewriteStatusMF';

function useOpenOrderRegular() {
  const { cb, key } = getV1MFOrder();

  const { data, fetchNextPage, hasNextPage, isInitialLoading, isFetchingNextPage } =
    useInfiniteQuery(key, cb, {
      getNextPageParam: (lastPage, allPages) => lastPage.data.next && allPages.length + 1,
      select: (datas) =>
        datas.pages?.flatMap((page) => {
          const iterateData = page.data.results.map((dataMF) => ({
            ...dataMF,
            mf_name: dataMF?.transaction[0]?.name,
            status_transaction: rewriteStatusMF(
              dataMF?.transaction[0]?.status_transaction,
              dataMF.type,
              dataMF.payment_method_data
            ),
          }));
          return iterateData;
        }),
    });

  const fetchNext = useCallback(() => {
    if (!isFetchingNextPage && hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, isFetchingNextPage, hasNextPage]);

  return {
    data: data || [],
    isInitialLoading,
    fetchNextPage: fetchNext,
    isFetchingNextPage,
  };
}

export default useOpenOrderRegular;
